import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
// react redux
import { useSelector } from "react-redux";
// react-hook-form
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// mui
import { Stack, FormControlLabel, Switch } from "@mui/material";
// componennts
import {
    PageTitle,
    SubmitButton,
    InputField,
    ImagePreview,
    ThreeDotsLoader,
} from "../../components";
// schema
import { editCategorySchema } from "../../schemes/category/editCategorySchema";
import { errorAlert, successAlert } from "../../utils/alerts/alerts";
// types
import { ReduxUserReducerState } from "../../types/global";
// form values type
type FormValues = {
    img?: File;
    name: string;
    is_disabled: boolean;
};
const EditCategory = () => {
    const navigate = useNavigate();
    const { categoryId } = useParams();
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [defaultImg, setDefaultImg] = useState("");
    // --------------------------- form handle ---------------------------
    const form = useForm<FormValues>({
        defaultValues: {
            img: undefined,
            name: "",
            is_disabled: false,
        },
        resolver: yupResolver(editCategorySchema),
        mode: "all",
    });
    const {
        register,
        setValue,
        getValues,
        reset,
        control,
        watch,
        formState: { errors },
        handleSubmit,
    } = form;
    const onSubmit: SubmitHandler<FormValues> = (data: any) => {
        const formData: any = new FormData();
        for (let key in data) {
            if (key === "parent") {
                formData.append(key, JSON.stringify(data[key]));
            } else {
                formData.append(key, data[key]);
            }
        }
        setSubmitting(true);
        EnhancedAxios("multipart/form-data", userToken)
            .put(`/admin/categories/${categoryId}`, formData)
            .then((res: AxiosResponse) => {
                successAlert(`تم تعديل تصنيف '${data.name}'`);
                setSubmitting(false);
                navigate(-1);
            })
            .catch((error: AxiosResponse) => {
                errorAlert(error);
                setSubmitting(false);
            });
    };
    // get category data
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/admin/categories/${categoryId}`)
            .then((res: any) => {
                setDefaultImg(res.data.img);
                reset({
                    name: res.data.name,
                    img: res.data.img,
                    is_disabled: res.data.is_disabled,
                });
                setLoading(false);
            })
            .catch((error: any) => {
                errorAlert(error);
            });
    }, []);
    if (loading) return <ThreeDotsLoader />;
    return (
        <Stack gap="20px">
            <PageTitle title="تعديل تصنيف" />
            <Stack alignItems="center">
                <Stack
                    width="100%"
                    maxWidth="800px"
                    gap="10px"
                    component="form"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <ImagePreview
                        setValue={setValue}
                        errorMessage={errors?.img?.message}
                        IPWidth="200px"
                        defaultImage={defaultImg}
                    />
                    <InputField
                        type="text"
                        registration={{ ...register("name") }}
                        label="الاسم"
                        errorMessage={errors?.name?.message}
                    />
                    <Controller
                        name="is_disabled"
                        control={control}
                        render={({ field }) => (
                            <FormControlLabel
                                control={
                                    <Switch
                                        {...field}
                                        checked={!watch("is_disabled")}
                                        onChange={(e) =>
                                            setValue(
                                                "is_disabled",
                                                !e.target.checked
                                            )
                                        }
                                    />
                                }
                                label="مفعل"
                            />
                        )}
                    />
                    <SubmitButton label="تعديل" disabled={submitting} />
                </Stack>
            </Stack>
        </Stack>
    );
};

export default EditCategory;
